import React from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, size = 16, onChange, interactive = false }) {
  const [hover, setHover] = React.useState(0);
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = (hover || value) >= n;
        return (
          <Star
            key={n}
            data-testid={interactive ? `star-${n}` : undefined}
            style={{ width: size, height: size }}
            className={`${filled ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"} ${interactive ? "cursor-pointer transition-transform hover:scale-110" : ""}`}
            onMouseEnter={interactive ? () => setHover(n) : undefined}
            onMouseLeave={interactive ? () => setHover(0) : undefined}
            onClick={interactive ? () => onChange?.(n) : undefined}
          />
        );
      })}
    </div>
  );
}
